<!-- @format -->

<ng-container *transloco="let t">
  @if (hasOpenUniversityOffering === false) {
    <p class="sis-guidance">{{ t("OPEN_UNIVERSITY.STUDY_OFFERING.NO_PRODUCTS") }}</p>
  }
  @if (hasOpenUniversityOffering) {
    @if (isCurrentOrgIdDifferentThanAllProductOrgIds) {
      <div class="mb-3">
        <sis-contextual-notification variant="warning">
          <span>
            {{
              t("OPEN_UNIVERSITY.STUDY_OFFERING.UNIVERSITY_ORG_ID_MISS_MATCH", {
                currentUniversityOrg: (currentOrgId | organisation | async)?.name | localizedString,
              })
            }}
          </span>
        </sis-contextual-notification>
      </div>
    }
    @if (courseUnit?.tweetText) {
      <p class="tweet-text">{{ courseUnit.tweetText | localizedStringWithoutFallback }}</p>
    }
    <div class="mb-5">
      <h3 data-cy="basic-info-header">{{ t("OPEN_UNIVERSITY.STUDY_OFFERING.BASIC_INFO") }}</h3>
      <app-course-unit-info-basic-info-header [courseUnit]="courseUnit"></app-course-unit-info-basic-info-header>
    </div>
    @if (productsLoading) {
      <div class="mb-5" data-cy="products-loading">
        <fudis-loading-spinner [label]="t('OPEN_UNIVERSITY.STUDY_OFFERING.LOADING_PRODUCTS')" />
      </div>
    } @else if (productsLoadFailed) {
      <div class="mb-5" data-cy="products-load-failed">
        <fudis-notification [variant]="'danger'">
          <fudis-body-text>{{ t("OPEN_UNIVERSITY.STUDY_OFFERING.LOADING_PRODUCTS_FAILED") }}</fudis-body-text>
        </fudis-notification>
        <div class="sis-mt-sm">
          <fudis-button
            [variant]="'secondary'"
            [label]="t('OPEN_UNIVERSITY.STUDY_OFFERING.RETRY_LOADING_PRODUCTS')"
            (handleClick)="retryProductFetch()"
            data-cy="retry-product-fetch" />
        </div>
      </div>
    } @else {
      <div class="mb-5">
        <div class="mb-5 mb-sm-0">
          <sis-tab-content-switch
            type="pills"
            [currentIndex]="currentTabIndex"
            (currentIndexChange)="onTabChange($event)"
            [tabs]="[
              { title: t('OPEN_UNIVERSITY.STUDY_OFFERING.CURRENT_TEACHING'), tail: currentProducts?.length || 0, id: 'header-0' },
              { title: t('OPEN_UNIVERSITY.STUDY_OFFERING.FUTURE_TEACHING'), tail: futureProducts?.length || 0, id: 'header-1' },
              { title: t('OPEN_UNIVERSITY.STUDY_OFFERING.PURCHASED_TEACHING'), tail: purchasedProducts?.length || 0, id: 'header-2' },
            ]">
          </sis-tab-content-switch>
        </div>
        @if (currentTabIndex === TAB.CURRENT_PRODUCTS) {
          <ng-container *ngTemplateOutlet="carousel; context: { products: currentProducts }"></ng-container>
        }
        @if (currentTabIndex === TAB.FUTURE_PRODUCTS) {
          <ng-container *ngTemplateOutlet="carousel; context: { products: futureProducts }"></ng-container>
        }
        @if (currentTabIndex === TAB.PURCHASED_PRODUCTS) {
          <ng-container *ngTemplateOutlet="carousel; context: { products: purchasedProducts }"></ng-container>
        }
        @if (!isMobileView && selectedProduct) {
          <div class="product-container">
            <app-product-details [courseUnit]="courseUnit" [product]="selectedProduct" [mobileView]="false"> </app-product-details>
          </div>
        }
      </div>
    }
  }

  <ng-template #carousel let-products="products">
    <h3 id="product-selection-header-tab-{{ currentTabIndex }}" [attr.data-cy]="'product-selection-header-tab-' + currentTabIndex">
      @if (currentTabIndex === TAB.CURRENT_PRODUCTS) {
        {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.CURRENT_TEACHING") }}
      }
      @if (currentTabIndex === TAB.FUTURE_PRODUCTS) {
        {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.FUTURE_TEACHING") }}
      }
      @if (currentTabIndex === TAB.PURCHASED_PRODUCTS) {
        {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.PURCHASED_TEACHING") }}
      }
    </h3>

    @if (currentTabIndex === TAB.PURCHASED_PRODUCTS && differentVersionEnrolmentRights?.length > 0) {
      <app-different-version-purchases
        [courseUnitGroupEnrolmentRights]="differentVersionEnrolmentRights"
        [currentCourseUnit]="courseUnit" />
    }

    @if (products.length) {
      <app-product-carousel
        [products]="products"
        [initialSelection]="selectedProduct?.id"
        [courseUnit]="courseUnit"
        [mobileView]="isMobileView"
        [name]="'products-on-sale-tab-' + currentTabIndex"
        [carouselHeaderId]="'products-on-sale-title' + currentTabIndex"
        (selected)="onProductSelect($event)">
      </app-product-carousel>
    }

    @if (!products.length) {
      <p class="sis-guidance" data-cy="no-products-guidance">
        @if (currentTabIndex === TAB.CURRENT_PRODUCTS) {
          {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.NO_CURRENT_PRODUCTS") }}
        }
        @if (currentTabIndex === TAB.FUTURE_PRODUCTS) {
          {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.NO_FUTURE_PRODUCTS") }}
        }
        @if (currentTabIndex === TAB.PURCHASED_PRODUCTS) {
          @if (userLoggedIn$ | async) {
            {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.NO_PURCHASED_PRODUCTS") }}
          } @else {
            {{ t("OPEN_UNIVERSITY.STUDY_OFFERING.NOT_LOGGED_IN_FOR_PURCHASED_PRODUCTS") }}
          }
        }
      </p>
    }
  </ng-template>
</ng-container>
